import { RadioOption, Radio } from './interface';

export default class RadioEntity {
    entityName: string;
    entity: Radio;

    constructor(name: string) {
        this.entity = {
            name,
            title: '',
            value: '',
            items: [],
        };
        this.entityName = name;
    }

    setTitle(title: string) {
        this.entity.title = title;

        return this;
    }

    setItems(items: RadioOption[]) {
        this.entity.items = items;

        return this;
    }

    setDefaultValue(value: string) {
        this.entity.value = value;

        return this;
    }
}
